import { HTTP } from "./http";
import { AuditEventAction, MimeType, } from "./types";
export class PIIScanner {
    constructor(mimeType, sessionId, url) {
        this._mimeType = mimeType;
        this._sessionId = sessionId;
        this._url = url;
    }
    static async create(mimeType) {
        const { sessionId, url } = await HTTP.createProject(this.baseUrl, mimeType);
        return new PIIScanner(mimeType, sessionId, url);
    }
    static restore({ mimeType, sessionId, url, }) {
        return new PIIScanner(mimeType, sessionId, url);
    }
    async events() {
        const { events } = await HTTP.listEvents(PIIScanner.baseUrl, this._sessionId);
        return events;
    }
    async finished() {
        const events = await this.events();
        return events.some((e) => e.action === AuditEventAction.ProjectWorkerSuccess ||
            e.action === AuditEventAction.ProjectWorkerFailed);
    }
    async progress() {
        return await HTTP.getProgress(PIIScanner.baseUrl, this._sessionId);
    }
    async results() {
        const response = await HTTP.getResults(PIIScanner.baseUrl, this._sessionId);
        return this._mimeType === MimeType.Txt ||
            this._mimeType === MimeType.Tsv
            ? (await response.text())
            : (await response.arrayBuffer());
    }
    export() {
        return {
            sessionId: this._sessionId,
            mimeType: this._mimeType,
            url: this._url,
        };
    }
    async uploadFile(file) {
        await HTTP.putFile(this._url, file);
    }
    async waitForResults(progress) {
        let events = await this.events();
        while (!(await this.finished())) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
            events = await this.events();
            progress === null || progress === void 0 ? void 0 : progress(events);
        }
        if (events.some((e) => e.action === AuditEventAction.ProjectWorkerFailed)) {
            throw new Error("Processing failed");
        }
        return await this.results();
    }
    async waitUntilFinished(progress) {
        while (!(await this.finished())) {
            if (progress) {
                progress(await this.progress());
            }
            await new Promise((resolve) => setTimeout(resolve, 1000));
        }
    }
    get mimeType() {
        return this._mimeType;
    }
}
PIIScanner.baseUrl = "https://pii.researchwiseai.com";
export { MimeType };
//# sourceMappingURL=index.js.map